import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { HomeServiceOrderCharge } from '@/models/homeService';

// Fragments
import './fragments/homeServiceOrderChargeFragment';

export const getHomeServiceOrderCharges = async (homeServiceOrderId: number) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      homeServiceOrderId,
    },
    query: graphql(`
      query HomeServiceOrderCharges($homeServiceOrderId: Float!) {
        homeServiceOrderCharges(homeServiceOrderId: $homeServiceOrderId) {
          ...HomeServiceOrderChargeFragment
        }
      }
    `),
  });

  return (response.data.homeServiceOrderCharges ?? []) as HomeServiceOrderCharge[];
};
